import { render, staticRenderFns } from "./TabelaRenda.vue?vue&type=template&id=538dc1a8&"
import script from "./TabelaRenda.vue?vue&type=script&lang=js&"
export * from "./TabelaRenda.vue?vue&type=script&lang=js&"
import style0 from "./TabelaRenda.vue?vue&type=style&index=0&id=538dc1a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports